import { render, staticRenderFns } from "./ModalCreateReservationEvent.vue?vue&type=template&id=0527cb84"
import script from "./ModalCreateReservationEvent.vue?vue&type=script&lang=js"
export * from "./ModalCreateReservationEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports